import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Search, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import NotificationBell from "@/components/NotificationBell";
import { MeetingSidebar } from "@/components/meeting/MeetingSidebar";

export default function MeetingAppShell() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="fixed inset-0 flex bg-[#070a12]" data-testid="meet-app-shell">
      <MeetingSidebar collapsed={collapsed} onToggleCollapse={() => setCollapsed((v) => !v)} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="h-16 shrink-0 border-b border-white/5 flex items-center gap-3 px-5">
          <div className="flex-1 max-w-md relative">
            <Search className="w-4 h-4 text-slate-500 absolute left-3 top-1/2 -translate-y-1/2" />
            <input
              placeholder="Search meetings, classes, people..." data-testid="meet-search-input"
              className="w-full bg-white/5 border border-white/10 rounded-lg pl-9 pr-3 py-2 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:ring-1 focus:ring-cyan-400"
            />
          </div>
          <div className="flex-1" />
          <button onClick={() => navigate("/premium")} data-testid="meet-upgrade-btn"
            className="hidden sm:flex items-center gap-1.5 text-xs font-semibold bg-gradient-to-r from-cyan-500 to-fuchsia-500 hover:opacity-90 text-white px-3.5 py-2 rounded-lg transition-opacity">
            <Sparkles className="w-3.5 h-3.5" /> Upgrade plan
          </button>
          <NotificationBell />
          <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center text-xs font-bold text-white shrink-0" data-testid="meet-user-avatar">
            {(user?.name || "?").slice(0, 2).toUpperCase()}
          </div>
        </header>
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
